// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1CT3X","label":"Radio_label__1NvW1","checkMark":"Radio_checkMark__8JeM8","disabled":"Radio_disabled__3cugZ"};